import { ImageOff } from "lucide-react";
import { useState } from "react";
import { cn } from "@/lib/cn";

export function GalleryImage({
  url,
  alt,
  className,
  contain = false,
  compact = false,
  loading = "lazy",
}: {
  url: string;
  alt: string;
  className?: string;
  contain?: boolean;
  compact?: boolean;
  loading?: "eager" | "lazy";
}) {
  const [failed, setFailed] = useState(false);
  if (failed)
    return (
      <span
        className={cn(
          "flex size-full flex-col items-center justify-center gap-2 bg-fog text-[14px] text-slate",
          className,
        )}
      >
        <span role="img" aria-label={`${alt} unavailable`}>
          <ImageOff className="size-6" aria-hidden="true" />
        </span>
        {!compact && <span>Photo unavailable</span>}
        {contain && !compact && (
          <button
            type="button"
            className="min-h-11 rounded-md px-3 font-semibold text-electric-800 hover:underline focus-visible:outline-2 focus-visible:outline-electric-700 focus-visible:outline-offset-2"
            onClick={() => setFailed(false)}
          >
            Retry photo
          </button>
        )}
      </span>
    );
  return (
    <img
      src={url}
      alt={alt}
      loading={loading}
      onError={() => setFailed(true)}
      className={cn("block size-full", contain ? "object-contain" : "object-cover", className)}
    />
  );
}
